import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { debounceTime, Subject } from 'rxjs';
import { ConfigService } from './service/config.service';

import { HttpErrorResponse } from '@angular/common/http';
import validationform from '../../../../validation/validationform';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrl: './configuration.component.scss'
})
export class ConfigurationComponent {

  editTopic: any;
  topicForm!: FormGroup;
  showCard = false;
  showButton = false;
  getIndex!: number;
  tabTriangle = 'topic';
  countCall!: number;
  countMetric!: number;
  stopWordTab = 'a';
  stopWordTblData: any = [];
  topicKeywordData: any = [];
  one = 1;
  weight = 'false';
  getId!: any;
  updateBoolean = false;
  splitPattern = new RegExp('[,;]');
  deleteIndex?: any;
  closeModal = false;
  myOptions!: object;
  survyData: any = [];
  survyTableData: any = [];
  isExpanded1 = false;
  isExpanded2 = false;
  isExpanded3 = false;
  isExpanded4 = false;
  NotificationData: any = [];
  notificationForm: FormGroup=new FormGroup({});
  stopWords = '';
  stopWords2: any = [];
  getStopWordIndex!: number;
  searchText = '';
  stopWordBtnShow: boolean = true;
  stopWordShowInput = 'edit';
  spinner = false;
  surveyForm!: FormGroup;
  surveyForm2!: FormGroup;
  tableTrVar!: number;
  expandTopicsAllTabsValue!: string;
  @ViewChild('closebutton') closebutton: any;
  private readonly notifier: NotifierService;
  @ViewChild('topicModal') topicModal: any;
  @ViewChild('accordionBtn1') accordionBtn1: any;
  @ViewChild('accordionBtn2') accordionBtn2: any;
  @ViewChild('accordionBtn3') accordionBtn3: any;
  @ViewChild('accordionBtn4') accordionBtn4: any;
  @ViewChild('addSurveySecondSectionId') addSurveySecondSectionId!: ElementRef;
  public stopWordSearch!: string;
  stopWordSearchUpdate = new Subject<string>();
  expandButtonShow: boolean = false;
  userDetails: any;
  metricFullscreen:boolean=false;
  disablepopup:boolean=false;

  constructor(private fb: FormBuilder, private configService: ConfigService,
    private notifierService: NotifierService,
    private cdRef: ChangeDetectorRef
  ) {
    this.notifier = notifierService;
    this.stopWordSearchUpdate.pipe(debounceTime(400)).subscribe((value) => {
      if (this.stopWordSearch) {
        this.getStopWordData(value, 'input');
      } else {
        this.getStopWordData('a', 'input');
      }
    });
  }




  ngOnInit(): void {
   // this.userDetails = this.appComponent.userDetailsAppComp;
    this.myOptions = {
      placement: 'top',
      hideDelay: 0,
      showDelay: 200,
      maxWidth: 200,
      trigger: 'hover',
      shadow: true,
      zIndex: 10000
    };
    this.topicForm = this.fb.group({
      call_type: [null, Validators.required],
      topic: [null, [Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      keywords: [''],
      alert_words: [''],
      sensitive_words: [''],
      hide_words: [''],
      delete_words: [''],
      pause_fillers: [''],
      positive_fillers: [''],
      mail_copies: ['',[Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      client_id: [''],
      pause_fillers_score: [null],
      metrics: this.fb.array([]),
      call_category: this.fb.array([]),
    });
   // this.topicForm.controls['client_id'].setValue(this.one);
    this.topicForm.controls['call_type'].setValue('inbound');
    this.getTopicData();

    this.notificationForm = this.fb.group({
      alert: [false],
      complete: [false],
      failure: [false],
    });

    this.surveyForm = this.fb.group({
      survey_name: [''],
      question_answers: this.fb.array([]),
    });


    this.topicForm.valueChanges.subscribe((res:any)=>{
   
      if(res['metrics'].length==0){
          this.topicForm.setErrors({ 'invalid': true });
      }

      if(res['metrics'].length > 0){
         res['metrics'].map((data:any)=>{
             if(data['category']=="" || data['category']==null){
               this.topicForm.setErrors({ 'invalid': true });
             }
             if(data['keywords'] != null){
               if(data['keywords'].length==0){
                 this.topicForm.setErrors({ 'invalid': true });
               }
               
             }
         });
      }

      if(res['call_category'].length==0){
       this.topicForm.setErrors({ 'invalid': true });
      }

      if(res['call_category'].length > 0){
       res['call_category'].map((data:any)=>{
           if(data['category']=="" || data['category']==null){
             this.topicForm.setErrors({ 'invalid': true });
           }
           if(data['keywords'] != null){
             if(data['keywords'].length==0){
               this.topicForm.setErrors({ 'invalid': true });
             }
             
           }
       });
    }
   });


  }

  get question_answers() {
    return this.surveyForm.controls['question_answers'] as FormArray;
  }

  surveyFirstSection(): FormArray {
    return this.surveyForm.get('question_answers') as FormArray;
  }

  addQuestion(): FormGroup {
    return this.fb.group({
      question: [null],
      answers: this.fb.array([]),
    });
  }

  addSurveyFirstSection(value?: string) {
    this.surveyFirstSection().push(this.addQuestion());
    if (value !== 'edit') {
      this.addSurveySecondSection(this.surveyFirstSection().length - 1);
    }
  }

  surveySecondSection(index: number): FormArray {
    return this.surveyFirstSection()?.at(index)?.get('answers') as FormArray;
  }

  addMoreData(): FormGroup {
    return this.fb.group({
      answer: [null],
      score: [null],
    });
  }

  addSurveySecondSection(index: number) {
    this.surveySecondSection(index)?.push(this.addMoreData());
  }

  exitSurveyModal() {
    this.surveyForm.reset();
    this.question_answers.clear();
    this.showButton = false;
  }

  getTopicData() {
    this.spinner = true;
     this.metricFullscreen=true;
     this.topicKeywordData = [];
    this.configService.getTopicKeyword().subscribe({
      next:(sub:any) => {
        this.topicKeywordData = sub;
        this.topicKeywordData.reverse();
        this.spinner = false;
      },
      error:(error:HttpErrorResponse) => {
        console.log('getTopicKeyword error', error);
        this.spinner = false;
      }
    });
  }

  tableBack(index: number) {
    this.tableTrVar = index;
  }

  onSubmit() {
    if (this.topicForm.valid) {
      this.disablepopup = false;
      const formValue = this.topicForm.value;
      const metricValue = formValue.metrics;
      // let metricArray = [];
      // for (let i = 0; i < metricValue.length; i++) {
      //   if (metricValue[i].weitage==true) {
      //     metricValue[i].weitage = 'true';
      //   } else {
      //     metricValue[i].weitage = 'false';
      //   }
      //   if (metricValue[i].active==true) {
      //     metricValue[i].active = 'true';
      //   } else {
      //     metricValue[i].active = 'false';
      //   }
      //   if (metricValue[i].free_score==true) {
      //     metricValue[i].free_score = 'true';
      //   } else{
      //     metricValue[i].free_score = 'false';
      //   }
      //   if (metricValue[i].negative_question==true) {
      //     metricValue[i].negative_question = 'true';
      //   } else {
      //     metricValue[i].negative_question = 'false';
      //   }

      //   if(metricValue[i].score_text_enable==true){
      //     metricValue[i].score_text_enable = 'true';
      //   } else{
      //     metricValue[i].score_text_enable = 'false';
      //   }

      //   metricArray.push(metricValue[i]);
      // }
       setTimeout(()=>{

       
          if(Array.isArray(this.topicForm.value.metrics)){
            if(this.topicForm.value.metrics.length > 0){
              for (let i = 0; i < this.topicForm.value.metrics.length; i++) {
                this.topicForm.value.metrics[i]['active'] = this.topicForm.value.metrics[i]['active']? 'true':'false';
                this.topicForm.value.metrics[i]['free_score'] = this.topicForm.value.metrics[i]['free_score']? 'true':'false';
                this.topicForm.value.metrics[i]['negative_question'] = this.topicForm.value.metrics[i]['negative_question']? 'true':'false';
                this.topicForm.value.metrics[i]['score_text_enable'] = this.topicForm.value.metrics[i]['score_text_enable']? 'true':'false';
                this.topicForm.value.metrics[i]['weitage'] = this.topicForm.value.metrics[i]['weitage']? 'true':'false';
              }
            }
          }

          const callCategoryValue = formValue.call_category;
          let callCategoryArray = [];
          for (let i = 0; i < callCategoryValue.length; i++) {
            if (callCategoryValue[i].active==true) {
              callCategoryValue[i].active = 'true';
            } else {
              callCategoryValue[i].active = 'false';
            }
            callCategoryArray.push(callCategoryValue[i]);
          }
          const keyword = formValue.keywords?.toString()
            ? formValue.keywords?.toString()
            : '';
          const alertKeyword = formValue.alert_words?.toString()
            ? formValue.alert_words?.toString()
            : '';
          const sensitiveKeyword = formValue.sensitive_words?.toString()
            ? formValue.sensitive_words?.toString()
            : '';
          const hideKeyword = formValue.hide_words?.toString()
            ? formValue.hide_words?.toString()
            : '';
          const deleteKeyword = formValue.delete_words?.toString()
            ? formValue.delete_words?.toString()
            : '';
          const negativeKeyword = formValue.pause_fillers
            ? formValue.pause_fillers
            : [];
          const positiveKeyword = formValue.positive_fillers
            ? formValue.positive_fillers
            : [];
          formValue.keywords = keyword;
          formValue.alert_words = alertKeyword;
          formValue.sensitive_words = sensitiveKeyword;
          formValue.hide_words = hideKeyword;
          formValue.delete_words = deleteKeyword;
          formValue.pause_fillers = negativeKeyword;
          formValue.positive_fillers = positiveKeyword;
          formValue.metrics = this.topicForm.value.metrics;
          formValue.call_category = callCategoryArray;
          //this.topicKeywordData.unshift(formValue);
          
          this.configService.saveTopics(formValue).subscribe({
           next: (sub:any) => {
              this.notifier.notify('default', 'Saved Successfully');
              this.exitIconReset();
              this.getTopicData();
            },
            error:(error:HttpErrorResponse) => {
              console.log('submitted error', error);
            }
           });
          this.closebutton.nativeElement.click();
        },5000);    
    } else {
      this.disablepopup = true;
      validationform.ValidateAllFormFields(this.topicForm);
    }
  }

  get call_category() {
    return this.topicForm.controls['call_category'] as FormArray;
  }

  get metrics() {
    return this.topicForm.controls['metrics'] as FormArray;
  }

  addcall_category() {
    const lessonForm = this.fb.group({
      active: [true],
      category: [null,[Validators.required,Validators.pattern(/^[A-Za-z]+(?:[A-Za-z0-9\/\&])+(?:\s[A-Za-z0-9\/\&\.]+)*[A-Za-z0-9\?\.]$/)]],
      keywords: [null, Validators.required],
      color: [null, Validators.required],
    });
    this.call_category.push(lessonForm);
    this.showCard = true;
  }

  deletecall_category(index: number) {
    this.call_category.removeAt(index);
  }

  addmetrics() {
  
      const lessonForm = this.fb.group({
        active: [true],
        category: [null,[Validators.required,Validators.pattern(/^[A-Za-z]+(?:[A-Za-z0-9\/\&])+(?:\s[A-Za-z0-9\/\&\.]+)*[A-Za-z0-9]{0,}$/)]],
        keywords: [null, Validators.required],
        score: [null, [Validators.required]],
        weitage: [false],
        free_score: [false],
        negative_question: [false],
        type_error:[null],
        score_text_enable:[false]
      });
      
      this.metrics.push(lessonForm);
     
    
    
   
    this.showCard = true;
  }

  deletemetrics(index: number) {
    this.metrics.removeAt(index);
  }

  getTopicsData(index: number) {
    this.spinner = true;
    this.updateBoolean = true;
    this.showButton = true;
    this.getIndex = index;
   // this.editTopic = this.topicKeywordData[index];
    this.getId = this.topicKeywordData[index].id?.$oid;
    this.editTopic = {};
    this.topicForm.reset();
    this.configService.getTopicConfigById(this.getId).subscribe({
      next:(res:any)=>{
         
           this.editTopic = res;
           const metricValue = this.editTopic.metrics;
           let metricArray:any = [];
            
            for (let i = 0; i < metricValue.length; i++) {
              if (metricValue[i].weitage === 'true') {
                metricValue[i].weitage = true;
              } else {
                metricValue[i].weitage = false;
              }
              if (metricValue[i].active === 'true') {
                metricValue[i].active = true;
              } else {
                metricValue[i].active = false;
              }
              if (metricValue[i].free_score === 'true') {
                metricValue[i].free_score = true;
              } else {
                metricValue[i].free_score = false;
              }
              if (metricValue[i].negative_question === 'true') {
                metricValue[i].negative_question = true;
              } else  {
                metricValue[i].negative_question = false;
              }

              if (metricValue[i].score_text_enable === 'true') {
                metricValue[i].score_text_enable = true;
              } else {
                metricValue[i].score_text_enable = false;
              }
              metricArray.push(metricValue[i]);
            }  

            const callCategoryValue = this.editTopic.call_category;
            let callCategoryArray = [];
            for (let i = 0; i < callCategoryValue.length; i++) {
              if (callCategoryValue[i].active === 'true') {
                callCategoryValue[i].active = true;
              } else {
                callCategoryValue[i].active = false;
              }
              callCategoryArray.push(callCategoryValue[i]);
            }
            const formObject = {
              call_type: this.editTopic.call_type,
              topic: this.editTopic.topic,
              keywords: this.editTopic.keywords
                ? this.editTopic.keywords?.split(',')
                : null,
              alert_words: this.editTopic.alert_words
                ? this.editTopic.alert_words?.split(',')
                : null,
              sensitive_words: this.editTopic.sensitive_words
                ? this.editTopic.sensitive_words?.split(',')
                : null,
              hide_words: this.editTopic.hide_words
                ? this.editTopic.hide_words?.split(',')
                : null,
              delete_words: this.editTopic.delete_words
                ? this.editTopic.delete_words?.split(',')
                : null,
              pause_fillers: this.editTopic.pause_fillers,
              positive_fillers: this.editTopic.positive_fillers,
              mail_copies: this.editTopic.mail_copies,
              metrics: metricArray,
              call_category: callCategoryArray,
            };
            this.topicForm.patchValue(formObject);
            this.cdRef.detectChanges();
              this.countCall =  this.editTopic.call_category.length;
            this.countMetric = formObject['metrics'].length;
            for (let i = 0; i < this.countCall; i++) {
              this.addcall_category();
              this.call_category.patchValue(this.editTopic.call_category);
            }
            for (let i = 0; i < this.countMetric; i++) {
              this.addmetrics();
             this.metrics.patchValue(this.editTopic.metrics);
            }
            this.disablepopup = true;
            this.spinner = false;
             this.showCard = true;
      },
      error:(error:HttpErrorResponse)=>{
        this.spinner = false;
        this.notifier.notify('default', 'Something went wrong');
        this.closebutton.nativeElement.click();
        this.exitIconReset();
        this.getTopicData();
      }
    });
    
  }

  updateForm() {
    if (this.topicForm.valid) {
     this.disablepopup = false;
       setTimeout(()=>{
          if(Array.isArray(this.topicForm.value.metrics)){
            if(this.topicForm.value.metrics.length > 0){
              for (let i = 0; i < this.topicForm.value.metrics.length; i++) {
                this.topicForm.value.metrics[i]['active'] = this.topicForm.value.metrics[i]['active']? 'true':'false';
                this.topicForm.value.metrics[i]['free_score'] = this.topicForm.value.metrics[i]['free_score']? 'true':'false';
                this.topicForm.value.metrics[i]['negative_question'] = this.topicForm.value.metrics[i]['negative_question']? 'true':'false';
                this.topicForm.value.metrics[i]['score_text_enable'] = this.topicForm.value.metrics[i]['score_text_enable']? 'true':'false';
                this.topicForm.value.metrics[i]['weitage'] = this.topicForm.value.metrics[i]['weitage']? 'true':'false';
              }
            }
          }
          //console.log("update form",this.topicForm.value.metrics);
          // const formValue2 = this.topicForm.value;
          // const metricValue = formValue2.metrics;
          // let metricArray = [];
          // for (let i = 0; i < metricValue.length; i++) {
          //   if (metricValue[i].weitage==true) {
          //     metricValue[i].weitage = 'true';
          //   } else {
          //     metricValue[i].weitage = 'false';
          //   }
          //   if (metricValue[i].active==true) {
          //     metricValue[i].active = 'true';
          //   } else  {
          //     metricValue[i].active = 'false';
          //   }
          //   if (metricValue[i].free_score==true) {
          //     metricValue[i].free_score = 'true';
          //   } else {
          //     metricValue[i].free_score = 'false';
          //   }
          //   if (metricValue[i].negative_question==true) {
          //     metricValue[i].negative_question = 'true';
          //   } else  {
          //     metricValue[i].negative_question = 'false';
          //   }

          //   if (metricValue[i].score_text_enable==true) {
          //     metricValue[i].score_text_enable = 'true';
          //   } else {
          //     metricValue[i].score_text_enable = 'false';
          //   }

          //   metricArray.push(metricValue[i]);
          // }

          const callCategoryValue = this.topicForm.value.call_category;
          let callCategoryArray = [];
          for (let i = 0; i < callCategoryValue.length; i++) {
            if (callCategoryValue[i].active==true) {
              callCategoryValue[i].active = 'true';
            } else {
              callCategoryValue[i].active = 'false';
            }
            callCategoryArray.push(callCategoryValue[i]);
          }
          const formValue = this.topicForm.value;
          const keyword = formValue.keywords ? formValue.keywords?.toString() : '';
          const alertKeyword = formValue.alert_words
            ? formValue.alert_words?.toString()
            : '';
          const sensitiveKeyword = formValue.sensitive_words
            ? formValue.sensitive_words?.toString()
            : '';
          const hideKeyword = formValue.hide_words
            ? formValue.hide_words?.toString()
            : '';
          const deleteKeyword = formValue.delete_words
            ? formValue.delete_words?.toString()
            : '';
          const negativeKeyword = formValue.pause_fillers
            ? formValue.pause_fillers
            : [];
          const positiveKeyword = formValue.positive_fillers
            ? formValue.positive_fillers
            : [];
          const mail_copies = formValue.mail_copies ? formValue.mail_copies : '';
          const id = this.topicKeywordData[0].id;
          const client_id = 1;
          const topic_ref_count = 0;

          formValue.client_id = client_id;
          formValue.keywords = keyword;
          formValue.alert_words = alertKeyword;
          formValue.sensitive_words = sensitiveKeyword;
          formValue.hide_words = hideKeyword;
          formValue.delete_words = deleteKeyword;
          formValue.pause_fillers = negativeKeyword;
          formValue.positive_fillers = positiveKeyword;
          formValue.mail_copies = mail_copies;
          formValue.topic_ref_count = topic_ref_count;
          formValue.id = id;
          formValue.metrics = this.topicForm.value.metrics;
          formValue.call_category = callCategoryArray;
          this.configService.updateTopic(this.getId, formValue).subscribe({
            next:(sub:any) => {
            
              this.notifier.notify('default', 'Updated Successfully');
              this.closebutton.nativeElement.click();
              this.exitIconReset();
              this.getTopicData();
            },
           error: (error:HttpErrorResponse) => {
              console.log('updated topic error', error);
            }
         });
        },5000);
    } else {
      validationform.ValidateAllFormFields(this.topicForm);
    }
  }

   

  exitIconReset() {
    setTimeout(() => {
      this.topicForm.reset();
      this.call_category.clear();
      this.metrics.clear();
      this.topicForm.controls['call_type'].setValue('inbound');
      if (this.isExpanded1) {
        this.accordionBtn1.nativeElement.click();
      }
      if (this.isExpanded2) {
        this.accordionBtn2.nativeElement.click();
      }
      if (this.isExpanded3) {
        this.accordionBtn3.nativeElement.click();
      }
      if (this.isExpanded4) {
        this.accordionBtn4.nativeElement.click();
      }
      this.expandButtonShow = false;
    }, 400);
  }

  expandTopicsAllTabs(value: string) {
    this.expandButtonShow = !this.expandButtonShow;
    this.expandTopicsAllTabsValue = value;
    if (value === 'collapse') {
      if (this.isExpanded1) {
        this.accordionBtn1.nativeElement.click();
      }
      if (this.isExpanded2) {
        this.accordionBtn2.nativeElement.click();
      }
      if (this.isExpanded3) {
        this.accordionBtn3.nativeElement.click();
      }
      if (this.isExpanded4) {
        this.accordionBtn4.nativeElement.click();
      }
    }

    if (value === 'expand') {
      if (!this.isExpanded1) {
        this.accordionBtn1.nativeElement.click();
      }
      if (!this.isExpanded2) {
        this.accordionBtn2.nativeElement.click();
      }
      if (!this.isExpanded3) {
        this.accordionBtn3.nativeElement.click();
      }
      if (!this.isExpanded4) {
        this.accordionBtn4.nativeElement.click();
      }
    }
  }

  toggleCollapsed(value: string) {
    let buttonShow = false;
    if (value === '1') {
      this.isExpanded1 = !this.isExpanded1;
      if (this.isExpanded1) {
        this.expandButtonShow = true;
      } else if (this.expandTopicsAllTabsValue === 'collapse') {
        this.expandButtonShow = false;
      }
    }
    if (value === '2') {
      this.isExpanded2 = !this.isExpanded2;
      if (this.isExpanded2) {
        this.expandButtonShow = true;
      } else if (this.expandTopicsAllTabsValue === 'collapse') {
        this.expandButtonShow = false;
      }
    }
    if (value === '3') {
      this.isExpanded3 = !this.isExpanded3;
      if (this.isExpanded3) {
        this.expandButtonShow = true;
      } else if (this.expandTopicsAllTabsValue === 'collapse') {
        this.expandButtonShow = false;
      }
    }
    if (value === '4') {
      this.isExpanded4 = !this.isExpanded4;
      if (this.isExpanded4) {
        this.expandButtonShow = true;
      } else if (this.expandTopicsAllTabsValue === 'collapse') {
        this.expandButtonShow = false;
      }
    }
    if (
      !this.isExpanded1 &&
      !this.isExpanded2 &&
      !this.isExpanded3 &&
      !this.isExpanded4
    ) {
      buttonShow = true;
      this.expandButtonShow = false;
    } else {
      this.expandButtonShow = true;
    }
  }

  showButtonFun() {
    this.showButton = false;
    this.updateBoolean = false;
    this.disablepopup = true;
  }

  deleteTopic(index: number) {
    const id = this.topicKeywordData[index]?.id?.$oid;
    this.configService.deleteTopicData(id).subscribe({
      next:(sub:any) => {
        this.topicKeywordData.splice(index, 1);
        this.notifier.notify('default', 'Deleted Successfully');
      },
      error:(error:HttpErrorResponse) => {
        console.log('delete error', error);
      }
    });
  }

  justShowIndex(index: number) {
    this.deleteIndex = index;
  }

  getSurveyData() {
    this.spinner = true;
    this.configService.getSurvey().subscribe({
      next: (response) => {
        this.survyData = response;
        this.survyTableData = this.survyData.result;
        this.spinner = false;
      },
      error: (err) => {
        this.spinner = false;
      },
    });
  }

  sendSurveyIndex(index: number) {
    this.showButton = true;
    for (let i = 0; this.survyTableData[index]?.question_answers.length > i; i++) {
      this.addSurveyFirstSection('edit');
      for (
        let j = 0; this.survyTableData[index]?.question_answers[i].answers.length > j; j++) {
        this.addSurveySecondSection(i);
      }
    }
    this.surveyForm.patchValue(this.survyTableData[index]);
  }

  deleteQuestionAnswerInputs(index: number, index2: number) {
    this.surveySecondSection(index2)?.removeAt(index);
  }

  deleteQuestionInput(index: number) {
    this.surveyFirstSection().removeAt(index);
  }

  stopWordTabFun(tab: string) {
    this.stopWordTab = tab;
  }

  getStopWordData(value: string, id: string) {
    this.stopWordBtnShow = true;
    this.spinner = true;
    if (id === 'tab') {
      this.stopWordSearch = '';
    }
    this.configService.getStopWord(value).subscribe({
      next: (response) => {
        const result: any = response;
        this.stopWordTblData = result.result;
        this.spinner = false;
      },
      error: (err) => {
        console.log(err);
        this.spinner = false;
      },
    });
  }

  showTriangle(value: string) {
    this.tabTriangle = value;
  }

  getNotificationData() {
    this.configService.getEmailConfiguration().subscribe({
      next: (response) => {
        this.NotificationData = response;
        this.updateNotification2();
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  updateNotification2() {
    if (this.NotificationData.alert_email === 'Y') {
      this.notificationForm.controls['alert'].setValue(true);
    }
    if (this.NotificationData.complete_email === 'Y') {
      this.notificationForm.controls['complete'].setValue(true);
    }
    if (this.NotificationData.failure_email === 'Y') {
      this.notificationForm.controls['failure'].setValue(true);
    }
  }

  updateNotification() {
    const formObject = {
      alert_email:
        this.notificationForm.controls['alert'].value === true ? 'Y' : 'N',
      complete_email:
        this.notificationForm.controls['complete'].value === true ? 'Y' : 'N',
      failure_email:
        this.notificationForm.controls['failure'].value === true ? 'Y' : 'N',
    };
    this.configService.updateEmailConfiguration(formObject).subscribe({
      next: (response) => {
        this.NotificationData = response;
        this.updateNotification2();
        this.notificationForm.markAsPristine();
        this.notifier.notify('default', 'Updated Sucessfully!');
      },
      error: (err) => {
        console.log(err);
        this.notifier.notify(
          'default',
          'server not respond, please try again after sometime!'
        );
      },
    });
  }

  sendStopWordIndex(index: number) {
    this.stopWordBtnShow = true;
    this.getStopWordIndex = index;
    this.stopWords = this.stopWordTblData[index];
  }

  changeInputStopWord() {
    this.stopWordBtnShow = false;
  }

  exitStopWord() {
    this.stopWordBtnShow = true;
    this.stopWords = '';
  }

  updateStopWordFun() {
    const formObject = {
      add_stop_words: [
        this.stopWordShowInput === 'edit'
          ? this.stopWords
          : this.stopWords2.toString(),
      ],
      hide_stop_words: [],
      rem_stop_words:
        this.stopWordShowInput === 'edit'
          ? [this.stopWordTblData[this.getStopWordIndex]]
          : [],
    };
    this.configService.updateStopWord(formObject).subscribe({
      next: (response) => {
        this.stopWordTblData[this.getStopWordIndex] =
          formObject.add_stop_words[0];
        this.getStopWordData('a', 'input');
        this.stopWordBtnShow = true;
      },
      error: (err) => {
        console.log(err);
        this.spinner = false;
      },
    });
  }

  DeleteStopWordFun(index: number) {
    this.getStopWordIndex = index;
    const formObject = {
      add_stop_words: [],
      hide_stop_words: [],
      rem_stop_words: [this.stopWordTblData[this.getStopWordIndex]],
    };
    this.configService.updateStopWord(formObject).subscribe({
      next: (response) => {
        this.getStopWordData('a', 'input');
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  stopWordModalOpen(value: string) {
    this.stopWordShowInput = value;
  }

  ValidateCheckbox(form:any,fieldName:any){
  
     if(form.controls[fieldName].value){
      return true;
    }else{
      return false;
    }
  }

   onKeywordsAdded(event:any,controlName:string){
    // var filter = /^[A-Za-z]+(?:[A-Za-z0-9\/\&])+(?:\s[A-Za-z0-9\/\&\.]+)*[A-Za-z0-9\?\.]$/;

    //     if (!filter.test(event.value)) {
    //         this.notifier.notify('error','Please provide a valid keywords');
    //         let tag_value =  this.topicForm.get(controlName)?.value;
    //         tag_value.splice(tag_value.length-1,1);
    //     }
  }

  onKeywordsAddedformArray(event:any,formgroup:any,index:number,controlName:string){
    // var filter = /^[A-Za-z]+(?:[A-Za-z0-9\/\&])+(?:\s[A-Za-z0-9\/\&\.]+)*[A-Za-z0-9\?\.]$/;

    //     if (!filter.test(event.value)) {
    //         this.notifier.notify('error','Please provide a valid keywords');
    //         let tag_value =  (this.topicForm.controls[formgroup] as FormArray).controls[index].get(controlName)?.value;
    //         tag_value.splice(tag_value.length-1,1);
    //     }
  }

}
